import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Select } from 'antd';
import TaxActions from '@Actions/taxActions';
import './style.scss';
import PRZSelect from '../../../Common/UI/PRZSelect';

const { Option } = Select;

/**
 *
 */
class SelectTax extends Component {
  /**
   * Constructor
   *
   * @param props
   */
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  /**
   *
   * @param props
   * @param state
   * @return {(*&)|*}
   */
  static getDerivedStateFromProps(props, state) {
    const {
      getTaxes, user, getTaxesLoading, taxesGroup,
    } = props;
    const { isUserReady } = state;
    if (user?.tenant_info?.org_id && !isUserReady && !getTaxesLoading && !taxesGroup?.data) {
      getTaxes(user?.tenant_info?.org_id, 1, 1000, null, true);
      return {
        ...state,
        isUserReady: true,
      };
    }
    return state;
  }

  /**
   *
   * @return {*}
   */
  render() {
    const {
      taxesGroup, onChange, selectedGST, disabled, showError, title, getTaxesLoading, customStyle, getPopupContainer, open, errorOutline, containerClassName, notRequired, noTax,
    } = this.props;
    return (
      <div className={containerClassName}>
        {title
          ? (
            <label className="orgFormLabel">
              {title}
              {notRequired ? '' : <span style={{ color: 'red' }}>{'  *'}</span>}
            </label>
          )
          : <label />}
        <PRZSelect
          getPopupContainer={getPopupContainer}
          value={!getTaxesLoading && (selectedGST || '')}
          open={open}
          filterOption={false}
          disabled={disabled || getTaxesLoading}
          onChange={(value) => value === 'noTax' ? null : onChange(taxesGroup?.data.filter((tax) => tax?.tax_id === value)[0])}
          style={{
            border: errorOutline ? '1px solid red' : 'none',
            borderRadius: '2px',
            height: '28px',
            width: '100%',
            fontSize: '13px',
            ...customStyle,
          }}
          allowClear={false}
        >
          {
            taxesGroup?.data?.map((item) => (
              <Option key={item?.tax_id} value={item?.tax_id}>
                {item.tax_name}
                {' '}
                -
                {' '}
                {item.tax_value}
                %
              </Option>
            ))
          }
        </PRZSelect>
        {showError && (
          <div className="input-error">
            *Please select Tax percentage
          </div>
        )}
      </div>

    );
  }
}

const mapStateToProps = ({ TaxReducers, UserReducers }) => ({
  getTaxesLoading: TaxReducers.getTaxesLoading,
  taxesGroup: TaxReducers.taxesGroup,
  user: UserReducers.user,
});

const mapDispatchToProps = (dispatch) => ({
  getTaxes: (orgId, page, limit, isActive, isGroup) => dispatch(TaxActions.getTaxes(orgId, page, limit, isActive, isGroup)),
});

SelectTax.propTypes = {
  user: PropTypes.any,
  taxesGroup: PropTypes.any,
  selectedGST: PropTypes.any,
  getTaxes: PropTypes.func,
  getTaxesLoading: PropTypes.bool,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  showError: PropTypes.bool,
  title: PropTypes.any,
  onlyTaxId: PropTypes.bool,
  customStyle: PropTypes.any,
  errorOutline: PropTypes.any,
  getPopupContainer: PropTypes.any,
  open: PropTypes.any,
  containerClassName: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(SelectTax));
